import {
  createSelector,
} from 'reselect';

import {
  getResourceMap,
  getResourceById,
  getSelectionResourceMappedList,
} from './resources';
import {
  alphSortByName,
} from './utils';

export const getDocumentAuthor = documentId => createSelector(
  [
    getResourceMap('clients'),
    getResourceById('documents', documentId),
  ],
  (clientsMap, document) => {
    const author = clientsMap[document?.owner_id];

    if (author) {
      return {
        id: author.id,
        fullName: `${author.user_profile.first_name} ${author.user_profile.last_name}`,
        avatar: author.user_profile.avatar?.thumb?.url,
      };
    }
    return {
      fullName: 'GymCloud',
    };
  },
);

export const getDocuments = (listName = 'library') => createSelector(
  getSelectionResourceMappedList('documents', listName),
  documents => documents.sort(alphSortByName),
);
